import React from "react";
import { Elements as StripeProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Home from "../pages/Home";

interface ProvidersProps {}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_LIVE_PK!);

const Providers: React.FC<ProvidersProps> = () => {
  return (
    <StripeProvider stripe={stripePromise}>
      <Home />
    </StripeProvider>
  );
};

export default Providers;
